export default "__VITE_ASSET__adfd3dc8__"